import { Element, ElementType } from '@ritabygglov/core';
import { createTrapezoidPath, createTrianglePath } from './shapes';

function getShapeClipPath(element: Element): string | null {
  switch (element.type) {
    case ElementType.Triangle:
      return createTrianglePath(element);
    case ElementType.Trapezoid:
      return createTrapezoidPath(element);
    default:
      return null;
  }
}

export const PatternFill = ({
  element,
  x,
  y,
  width,
  height,
  patternValue,
}: {
  element: Element;
  x: number;
  y: number;
  width: number;
  height: number;
  patternValue: string;
}) => {
  const clipPathD = getShapeClipPath(element);
  const clipId = `clip-${element.id}`;
  return (
    <>
      {clipPathD && (
        <defs>
          <clipPath id={clipId}>
            <path d={clipPathD} />
          </clipPath>
        </defs>
      )}
      <rect
        id={`${element.id}-hatch`}
        x={x}
        y={y}
        width={width}
        height={height}
        fill={patternValue}
        clipPath={clipPathD ? `url(#${clipId})` : undefined}
      />
    </>
  );
};
